import api, { getApiErrorMessage } from "./api";

// Sorgente unica per /auth/validate, con cache di 30 secondi e una sola
// richiesta in volo (vedi la nota su gestionale-gls: richieste doppie al
// mount e ai cambi di scheda finivano nel rate limit e sloggavano l'utente).

const TTL_MS = 30_000;
const MIN_INTERVAL_MS = 10_000;

let validateCache = null;
let validatePromise = null;
let lastFetchAt = 0;

export function classifyValidateError(error) {
  if (error?.prKind) return error.prKind;
  const status = error?.response?.status;
  if (status === 401) return "auth";
  if (status === 403) return "forbidden";
  return "transient";
}

export function getValidate({ force = false } = {}) {
  const now = Date.now();
  if (validatePromise) return validatePromise;
  const age = now - (validateCache?.ts ?? 0);
  if (validateCache && (age < TTL_MS || (force && now - lastFetchAt < MIN_INTERVAL_MS))) {
    return Promise.resolve(validateCache.data);
  }
  lastFetchAt = now;
  validatePromise = api
    .get("/auth/validate")
    .then((res) => {
      if (res.data && res.data.valid === false) {
        const err = new Error("Sessione non valida");
        err.prKind = "auth";
        throw err;
      }
      validateCache = { ts: Date.now(), data: res.data };
      return res.data;
    })
    .catch((err) => {
      err.prKind = classifyValidateError(err);
      err.prMessage = getApiErrorMessage(err, "Impossibile verificare la sessione.");
      throw err;
    })
    .finally(() => {
      validatePromise = null;
    });
  return validatePromise;
}

export function invalidateAuthValidateCache() {
  validateCache = null;
}

export function getLastGoodValidate() {
  if (!validateCache) return null;
  return { data: validateCache.data, ageMs: Date.now() - validateCache.ts };
}
